<template>
    <div>
        <b-modal
            id="consent_survey_modal"
            modal-class=""
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-head">
                    <p id="headline" v-html="headline"></p>
                </div>
                <div class="modal-base-body">
                    <div id="message" v-html="content"></div>
                    <div class="wrapper-check">
                        <div class="img-check">
                            <img v-if="!isCheck" @click="isCheck = true" src="@/assets/icon/checkbox_inactive@2x.png" />
                            <img v-if="isCheck" @click="isCheck = false" src="@/assets/icon/checkbox_active@2x.png" />
                        </div>
                        <div class="agree">{{lblConsent.agree}}</div>
                    </div>
                </div>
                <div class="modal-base-footer">
                    <div class="col-btn wrapper-btn-next">
                        <div class="btn btn-secondary btn-next" @click="clickNext()">{{lblConsent.btn_next}}</div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
//import Vue from "vue";
import Util from "@/helper/Utility.js";
import Moment from "moment";
import Locale from "@/helper/locale/locale.js";

export default {
    name: 'ConsentSurveyModal',
    props: {
        lbl: Object,
        busModal: Object
    },
    data: function () {
        return {
            headline: '',
            content: '',
            isCheck: false,

            lblConsent: {},
            lblDate: {}
        };
    },
    mounted: function () {
        this.lblDate = this.lbl.date;
        this.lblConsent = this.lbl.consent;
        this.busModal.$on('showConsentSurvayModal', this.initialConsentSurvayModal);
        this.busModal.$on('hideConsentSurvayModal', this.closeConfirmModal);
    },
    methods: {
        //Event
        clickNext: function () {
            this.$emit('clickNext', {'isCheck': this.isCheck});
            this.closeConfirmModal();
        },
        clickCloseConfirmRedeem: function () {
        },
        initialConsentSurvayModal: function (objConsent) {
            this.isCheck = false;
            this.headline = this.lblConsent.headline;
            this.content = objConsent.consentMessage.replace("☑", "<div class='checkbox'></div>");

            this.$bvModal.show('consent_survey_modal');
        },
        //Function

        closeConfirmModal: function () {
            this.$bvModal.hide('consent_survey_modal');
        },
        //Utilities
        getTimerMessage: function (message, minutes) {
            var result = '';
            var days = '';
            var hours = '';
            var minuteAfterUsed = minutes;
            if (minuteAfterUsed >= 60) {
                hours = Math.floor(minuteAfterUsed / 60);
                if (hours >= 24) days = Math.floor(hours / 24);
            }

            if (days) result += days + ' ' + this.lblDate.days + ' ';
            if (hours) result += hours + ' ' + this.lblDate.hours + ' ';
            if (minutes / 60 > 0) result += (minutes % 60) + ' ' + this.lblDate.minutes_short;

            return Util.stringFormat(message, result);
        },
        getDrawMessage: function (message) {
            var expireDate = this.campaign.expireDate;
            var result = Moment.unix(expireDate).utc();
            var year = Moment.unix(expireDate).utc().format('YYYY');
            if (Locale.getLocaleCode() === 1054) year = result.get('year') + 543;

            var monthString = this.lblDate.month_short[result.format('M') - 1];
            var strDate = result.format('DD') + " " + monthString + " " + year
                        + ' | ' + result.format('HH:mm');

            return Util.stringFormat(message, strDate);
        }
    }
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/common.scss";
    #headline {
        text-align: center;
        font-size: 28px;
        background-color: $blue-color;
        color: white;
        padding: 25px 0;
        margin-bottom: 0;
    }

    #message {
        line-height: 1.3;
        padding: 15px 25px;
        margin-bottom: 0;
        height: calc(100vh - 238px);
        overflow-y: scroll;


    }

    .wrapper-check {
        width: 100%;
        display: flex;
        .img-check {
            width: 55px;
            padding: 0 15px 0 25px;
            img {
                width: 100%;
            }
        }
        .agree {
            width: calc(100% - 55px);
            line-height: 1;
            padding: 5px 0;
        }
    }

    .modal-base-footer {
        display: flex;
        width: 100%;

        .col-btn {
            width: 100%;
            display: flex;
            &.wrapper-btn-next {
                padding: 15px;
                .btn-next{
                    width: 100%;
                    font-size: 26px;
                    background-color: $blue-color;
                    color: white;
                    border: 0;
                    padding: 10px 0;

                    &.disable {
                        background-color: $background-gray-btn-cancel-color;
                    }
                }
            }
        }
    }



</style>
<style lang="scss">
    #consent_survey_modal {
        .modal-dialog {
            margin: 0;
            height: 100vh;
            max-width: 100%;
            .modal-content {
                border-radius: 0;
                height: 100vh;
                .modal-body {
                    padding: 0;

                    #message {
                        .checkbox {
                            width: 15px;
                            height: 15px;
                            background-image: url(../../assets/icon/checkboxshow@2x.png);
                            background-size: 100%;
                            background-repeat: no-repeat;
                            display: inline-block;
                        }
                    }
                }
            }
        }
    }
</style>
